import { useGetMercadoReasonLabel } from 'hooks/business/refundReason/useGetMercadoReasonLabel';
import { useGetReasonLabel } from 'hooks/business/refundReason/useGetReasonLabel';
import { useMemo } from 'react';
import { toUpperCase } from 'utils/toLowerCase';

export interface ReturnReasonLabelProps {
  platform?: General.PlatformUpperCase | General.Platform;
  reason?: string;
  reasonName?: string;
  reassessedRequestReason?: string;
}

export const useReturnReasonLabel = (props: ReturnReasonLabelProps) => {
  const { platform, reason, reasonName, reassessedRequestReason } = props;
  const { getReasonLabel } = useGetReasonLabel();
  const getMercadoReasonLabel = useGetMercadoReasonLabel();
  const upperPlatform = toUpperCase(platform);

  const reasonLabel = useMemo(() => {
    if (upperPlatform === 'MERCADO') {
      return getMercadoReasonLabel(reasonName);
    } else if (reason) {
      return getReasonLabel(reason, upperPlatform) || reason;
    }
  }, [getMercadoReasonLabel, getReasonLabel, reason, reasonName, upperPlatform]);

  const reassessedRequestReasonLabel = useMemo(() => {
    if (reassessedRequestReason && reassessedRequestReason !== 'NONE') {
      return getReasonLabel(reassessedRequestReason, upperPlatform) || reassessedRequestReason;
    }
  }, [getReasonLabel, reassessedRequestReason, upperPlatform]);

  return {
    reasonLabel,
    reassessedRequestReasonLabel,
  };
};
